/* eslint-disable @typescript-eslint/no-non-null-assertion */
declare global {
  interface Window {
    __configuration__: Record<string, string>;
  }
}
window.__configuration__ = window.__configuration__ || {};

function isUsable(value?: string): value is string {
  if (!value) {
    return false;
  }
  const trimmed = value.trim();
  if (!trimmed || trimmed === "REPLACE_ME") {
    return false;
  }
  if (trimmed.includes("{") || trimmed.includes("}")) {
    return false;
  }
  return true;
}

/** Helm / generate-env.sh wins over CircleCI-baked process.env. */
export function runtimeConfig(key: string): string | undefined {
  const fromWindow = window.__configuration__?.[key];
  const fromEnv = process.env[key];
  if (isUsable(fromWindow)) {
    return fromWindow;
  }
  if (isUsable(fromEnv)) {
    return fromEnv;
  }
  return undefined;
}

export function resolveRedirectUri(): string {
  const raw = runtimeConfig("REACT_APP_AUTH_REDIRECT_URI");
  if (!raw) {
    return `${window.location.origin}/login/callback`;
  }
  if (/^https?:\/\//i.test(raw)) {
    return raw;
  }
  return `${window.location.origin}${raw.startsWith("/") ? raw : `/${raw}`}`;
}

export const r_apgtwy = runtimeConfig("REACT_APP_API_GATEWAY_URL");

interface PortalConfiguration {
  apiUrl: string; // REACT_APP_API_URL=https://api.ecomm.reecedev.us/
  gatewayUrl: string; // REACT_APP_API_GATEWAY_URL=
  ec2Url: string; // REACT_APP_API_EC2_URL= http://ec2-44-193-210-2.compute-1.amazonaws.com
  ec2Key: string; // REACT_APP_API_EC2_KEY
  countPollingInterval: string; //  REACT_APP_COUNT_POLLING_INTERVAL=1500
  exportFunction: string; // REACT_APP_EXPORT_FUNCTION=true
  maxBodyWidth: number;
  maxContentWidth: number;
}

export const Configuration: PortalConfiguration /* & TestConfiguration */ = {
  apiUrl: runtimeConfig("REACT_APP_API_URL") ?? "",
  gatewayUrl: runtimeConfig("REACT_APP_API_GATEWAY_URL") ?? "",
  ec2Url: runtimeConfig("REACT_APP_API_EC2_URL") ?? "",
  ec2Key: runtimeConfig("REACT_APP_API_EC2_KEY") ?? "",
  countPollingInterval: runtimeConfig("REACT_APP_COUNT_POLLING_INTERVAL") ?? "",
  exportFunction: runtimeConfig("REACT_APP_EXPORT_FUNCTION") ?? "",
  maxBodyWidth: 52428800,
  maxContentWidth: 52428800,
};

export const entraIdConfig = {
  clientId: runtimeConfig("REACT_APP_AZURE_CLIENT_ID") || "{clientId}",
  authority:
    runtimeConfig("REACT_APP_AZURE_AUTHORITY") ||
    "https://login.microsoftonline.com/{tenantId}",
  redirectUri: resolveRedirectUri(),
  scopes: ["User.Read", "openid", "profile", "email"],
};

export const BASIC_AUTH = parseBasicAuth();

function parseBasicAuth() {
  if (r_apgtwy?.includes("external-dev")) {
    return btoa("MDBmODQxZmY:ZjcwNTkwNjc");
  } else if (r_apgtwy?.includes("external-test")) {
    return btoa("ZHk3fPyow9zW0K:WtL8nrMP+69D7JgYZ");
  } else if (r_apgtwy?.includes("external-uat")) {
    return btoa("ZHk3fPyow9zW0K:MUw0Ibk2qNmzOHiMi+y");
  } else if (r_apgtwy?.includes("external-stage")) {
    return btoa("KCAQEAp2HKT:D2zHeO36++IMGi1Bs");
  } else if (r_apgtwy?.includes("external-prod")) {
    return btoa("XTvpLMt7XzO6:Xc7ud4+PR76XbA9");
  } else return btoa("MDBmODQxZmY:ZjcwNTkwNjc");
}
